import { Extension } from '@tiptap/core';
import {
    ZyITLabGoalNode,
    ZyITLabGoalNodeHeadless,
    ZyITLabInstructionsNode,
    ZyITLabInstructionsNodeHeadless,
    ZyITLabModelSolutionNode,
    ZyITLabModelSolutionNodeHeadless,
    ZyITLabNode,
    ZyITLabNodeHeadless,
    ZyITLabStepInstructionsNode,
    ZyITLabStepInstructionsNodeHeadless,
    ZyITLabStepNode,
    ZyITLabStepNodeHeadless,
    ZyITLabTaskInstructionsNode,
    ZyITLabTaskInstructionsNodeHeadless,
    ZyITLabTaskNode,
    ZyITLabTaskNodeHeadless,
    ZyITLabVmImageNode,
    ZyITLabVmImageNodeHeadless,
    ZyITLabVmImagesNode,
    ZyITLabVmImagesNodeHeadless,
    ZyITLabVmImageTestNode,
    ZyITLabVmImageTestNodeHeadless,
} from './zyitlab-extension';

export const ZyITLabHeadless = Extension.create({
    name: 'zyITLabWrapper',

    addExtensions() {
        return [
            ZyITLabVmImageTestNodeHeadless,
            ZyITLabGoalNodeHeadless,
            ZyITLabStepInstructionsNodeHeadless,
            ZyITLabTaskInstructionsNodeHeadless,
            ZyITLabStepNodeHeadless,
            ZyITLabTaskNodeHeadless,
            ZyITLabVmImageNodeHeadless,
            ZyITLabVmImagesNodeHeadless,
            ZyITLabModelSolutionNodeHeadless,
            ZyITLabInstructionsNodeHeadless,
            ZyITLabNodeHeadless,
        ];
    },
});

export const ZyITLab = ZyITLabHeadless.extend({
    addExtensions() {
        return [
            ZyITLabVmImageTestNode,
            ZyITLabGoalNode,
            ZyITLabStepInstructionsNode,
            ZyITLabTaskInstructionsNode,
            ZyITLabStepNode,
            ZyITLabTaskNode,
            ZyITLabVmImageNode,
            ZyITLabVmImagesNode,
            ZyITLabModelSolutionNode,
            ZyITLabInstructionsNode,
            ZyITLabNode,
        ];
    },
});

export default ZyITLab;
